export const global = {
  login: 'Anmelden',
  logout: 'Abmelden',
  tableShowingToFrom: 'Showing {showing} to {to} from {from}',
  tableSearch: 'Keyword eingeben...',
  loading: 'Loading...'
}
